<template>
  <b-modal title="Edit sections" class="modal-light" v-model="showModal" @ok="submit" @cancel="undo" size='lg'>
    <ul ref='sections' class='list-group'>
      <li v-for="section in sections" :key='section.id' class='list-group-item list-group-item-action d-flex justify-content-between align-items-center' :data-id="section.id">
        <input v-if='section.editing === true' type='text' :value="section.name" v-on:keyup="updateCurrentName(section.id, $event)" />
        <span v-if='section.editing === false'> {{ section.name }} </span>
        <v-select v-if='section.editing === true' class='select-no-caret dashboards' value='move to dashboard' v-on:input="setDashboard(section.id, $event)" :options="dashboards" />
        <b-form-checkbox v-if='section.editing === true' label='Custom Content' v-model="section.custom_content" unchecked-value="false">Custom Content</b-form-checkbox>
        <div>
          <span class="badge badge-primary badge-pill m-1 p-2" v-on:click="editSectionName(section.id)"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
          <span class="badge badge-danger badge-pill m-1 p-2" v-on:click="deleteSection(section.id)"><i class="fa fa-trash-o" aria-hidden="true"></i></span>
        </div>
      </li>
    </ul>
  </b-modal>
</template>

<script>

import Sortable from "sortablejs"
import vSelect from 'vue-select'

export default {
  name: 'EditSectionModal',
  components: {
    vSelect
  },

  created () {
    this.$eventBus.$on('editSections', this.editSections)
    this.loadDashboards()
  },

  beforeDestroy() {
    this.$eventBus.$off('editSections')
  },

  data () {
    return {
      showModal: false,
      sections: [],
      dashboards: []
    }
  },

  methods: {
    setDashboard (sectionId, dashboard) {
      this.sections.forEach(function(section){
        if (sectionId === section.id){
          section.dashboard_id = dashboard.id
        }
      }.bind(this))
    },

    loadDashboards () {
      this.$http.get('/dashboards')
        .then(response => this.setDashboards(response))
        .catch((e) => console.log(e))
    },

    setDashboards (response) {
      response.data.data.forEach(function(dashboard){
        this.dashboards.push({
          id: dashboard.id,
          label: dashboard.attributes.name
        })
        if (this.$route.params.id === dashboard.id){
          this.dashboard = {
            id: dashboard.id,
            label: dashboard.attributes.name
          }
        }
      }.bind(this))
      this.dashboards = this.dashboards.sort((a,b) => a.label.localeCompare(b.label))
    },

    deleteSection (id) {
      if (window.confirm("Do you really want to delete section?")) {
        this.$http.delete('/dashboards/' + this.$route.params.id + '/sections/' + id)
          .then(function(response){
            if (response.status === 200){
              this.sections.forEach(function(section, index){
                if (section.id === id){
                  this.sections.splice(index, 1)
                }
              }.bind(this))
            }
          }.bind(this))
      }
    },

    updateCurrentName (id, event) {
      this.sections.map(function(section){
        if (section.id === id){
          section.name = event.target.value
        }
        return section
      }.bind(this))
    },

    editSectionName (sectionId) {
      this.sections = this.sections.map(function(section){
        section.id === sectionId ? section.editing = true : section.editing = false
        return section
      }.bind(this))
    },

    editSections () {
      this.showModal = true
      this.sections = this.$parent.sections.map(function(section){
        section.editing = false
        section.dashboard_id = this.$route.params.id
        return section
      }.bind(this))
      Sortable.create(this.$refs.sections, {store: { set: this.sortableSet }})
    },

    sortableSet (sortable) {
      var ids = sortable.toArray()
      var sections = ids.map(function(id, index){
        var section = this.sectionById(id)
        section.order = index
        return section
      }.bind(this))
      this.sections = sections
    },

    submit () {
      this.sections.forEach((section) => this.updateSection(section.id))
      setTimeout(this.$parent.loadSections, 1000)
    },

    updateSection (id) {
      var section = this.sectionById(id)
      var params = {
        section: {
          order: section.order,
          name: section.name,
          dashboard_id: section.dashboard_id,
          custom_content: section.custom_content
        }
      }
      this.$http.patch('/dashboards/' + this.$route.params.id + '/sections/' + id, params)
        .then(function(response){
          console.log(response.status)
        }.bind(this))
    },

    sectionById (id) {
      return this.sections.find((section) => parseInt(section.id, 10) === parseInt(id, 10))
    },

    undo () {
      setTimeout(this.$parent.loadSections, 500)
    }

  }

}
</script>

<style scoped>
.badge {
  cursor: pointer;
  min-width: 28px;
  min-height: 28px;
}
.badge i {
  font-size: 12px;
}
.dashboards {
  min-width: 20em;
}
</style>
